export default __webpack_public_path__ + "assets/radio-border.cb5b2563.svg";